import logo from "../../images/logoSimple.png";
import { TextField, Grid, Typography, Alert, Container } from "@mui/material";
import React, { useState, useEffect } from "react";
import { useApi } from "../../utils/api";
import { useAuth } from "../../utils/auth";
import LoadingButton from "@mui/lab/LoadingButton";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [forgotPassword, setForgotPassword] = useState(false);
  const { getUser } = useApi();
  const { user, login, sendResetPassword, error } = useAuth();

  useEffect(() => {
    const redirect = async () => {
      const userInfo = await getUser(user.uid);
      if (userInfo) {
        if (userInfo.isCoach) {
          window.location.href = "/clients";
        } else {
          window.location.href = "/workouts";
        }
      }
    };
    if (user) redirect();
  }, [user]);

  useEffect(() => {
    setLoading(false);
  }, [error]);

  const signIn = async () => {
    setLoading(true);
    await login(email, password);
  };

  const sendForgotPasswordEmail = async () => {
    setLoading(true);
    await sendResetPassword(email);
    setSuccess("Reset password email sent. Please check your email.");
    setLoading(false);
  };

  return (
    <Container maxWidth="sm">
      <Grid
        item
        display="flex"
        flexDirection="column"
        alignItems="center"
        lg={4}
      >
        <img src={logo} height="80" width="80" />
        {forgotPassword ? (
          <>
            <Typography sx={{ mb: 3 }} variant="h6">
              Forgot Password
            </Typography>
            {success && (
              <Alert severity="success" fullWidth sx={{ mb: 3, width: "100%" }}>
                {success}
              </Alert>
            )}
            {error && (
              <Alert severity="error" fullWidth sx={{ mb: 3, width: "100%" }}>
                {error}
              </Alert>
            )}
            <TextField
              size="small"
              fullWidth
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              label="Email"
              sx={{ mb: 3 }}
            />
            <LoadingButton
              variant="contained"
              fullWidth
              onClick={sendForgotPasswordEmail}
              loading={loading}
            >
              Send Reset Password Email
            </LoadingButton>
            <Typography
              variant="caption"
              sx={{ mt: 5, cursor: "pointer" }}
              onClick={() => setForgotPassword(false)}
            >
              Cancel
            </Typography>
          </>
        ) : (
          <>
            <Typography sx={{ mb: 3 }} variant="h6">
              Sign In
            </Typography>
            {success && (
              <Alert severity="success" fullWidth sx={{ mb: 3, width: "100%" }}>
                {success}
              </Alert>
            )}
            {error && (
              <Alert severity="error" fullWidth sx={{ mb: 3, width: "100%" }}>
                {error}
              </Alert>
            )}
            <TextField
              size="small"
              fullWidth
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              label="Email"
              sx={{ mb: 3 }}
            />
            <TextField
              size="small"
              fullWidth
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              label="Password"
              sx={{ mb: 3 }}
            />
            <LoadingButton
              variant="contained"
              fullWidth
              onClick={signIn}
              loading={loading}
            >
              Sign In
            </LoadingButton>
            <Typography
              variant="caption"
              sx={{ mt: 5, cursor: "pointer" }}
              onClick={() => setForgotPassword(true)}
            >
              Forgot password?
            </Typography>
          </>
        )}
      </Grid>
    </Container>
  );
};

export default Login;
